export default {"src":"/_next/static/media/signup_icon_1.3cfdc138.svg","height":34,"width":29};